var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresupuestoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#7000FF",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 9H10.7778C10.3063 9 9.8541 9.1873 9.5207 9.5207C9.1873 9.8541 9 10.3063 9 10.7778V23.2222C9 23.6937 9.1873 24.1459 9.5207 24.4793C9.8541 24.8127 10.3063 25 10.7778 25H23.2222C23.6937 25 24.1459 24.8127 24.4793 24.4793C24.8127 24.1459 25 23.6937 25 23.2222V14.3333L19.6667 9ZM23.2222 23.2222H10.7778V10.7778H18.7778V15.2222H23.2222V23.2222ZM21.4444 18.7778H12.5556V17H21.4444V18.7778ZM18.7778 21.4444H12.5556V19.6667H18.7778",
    fill: "#7000FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresupuestoNew);
export default __webpack_public_path__ + "static/media/presupuestoNew.d4e2c54e524249678e2f8f27421fa5bd.svg";
export { ForwardRef as ReactComponent };